import type { Router } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export function setupAuthGuards(router: Router) {
  router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore()
    
    // Verificar se a rota requer autenticação
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth !== false)
    
    // Se não requer autenticação, permitir acesso
    if (!requiresAuth) {
      next()
      return
    }
    
    // Verificar se está autenticado
    if (authStore.isAuthenticated) {
      next()
      return
    }
    
    // Tentar restaurar autenticação do storage
    authStore.loadAuthFromStorage()
    
    if (authStore.isAuthenticated) {
      next()
      return
    }
    
    // Redirecionar para login se não estiver autenticado
    next('/login')
  })
} 